export default __webpack_public_path__ + "static/media/6. Zayavlenie na peremarkirovku proby.b8d1f0b6.pdf";